import { T } from '@/lib/theme'

/// Section-level heading for the merged dashboard - one step down from
/// PageShell's old page-level `<h1>`, since five of these now share one
/// page instead of each owning its own masthead.
export function SectionHeader({ title, subtitle, actions = null }) {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap', marginBottom: 20 }}>
      <div>
        <h2 style={{
          fontSize: 26, fontWeight: 700, color: T.text, fontFamily: T.fontD,
          margin: 0, letterSpacing: '0.01em',
        }}>{title}</h2>
        {subtitle && (
          <p style={{ fontSize: T.fs.body, color: T.textMuted, fontFamily: T.fontM, marginTop: 6, marginBottom: 0 }}>
            {subtitle}
          </p>
        )}
      </div>
      {actions}
    </div>
  )
}
